declare var rootUrl: string;

export const logReactErrorToServer = (error: Error, errorInfo: React.ErrorInfo) => {
    fetch(`${rootUrl}Errors/ClientSideError`, {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify({ message: error.message, stack: error.stack, componentStack: errorInfo.componentStack }),
    });
}

export const logErrorToServer = (error: Error, componentError: string = null) => {
    fetch(`${rootUrl}Errors/ClientSideError`, {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify({ message: error.message, stack: error.stack, componentStack: componentError }),
    });
}
